<template>
  <de-container style="background-color: #f7f8fa">
    <de-main-container :class="{ 'full-height': fullHeightFlag }">
      <panel-edit />
    </de-main-container>
  </de-container>
</template>

<script>
import bus from '@/utils/bus'
import PanelEdit from '@/views/panel/edit'
import DeContainer from '@/components/dataease/DeContainer'
import DeMainContainer from '@/components/dataease/DeMainContainer'
export default ({
  beforeRouteLeave(to, from, next) {
    // this.$store.dispatch('panel/setPanelInfo', {})
    bus.$emit('PanelSwitchComponent', { name: 'PanelMain' })
    next()
    // if (this.componentName === 'PanelEdit') {
    //   next(false)
    //   if (confirm(this.$t('panel.edit_leave_tips'))) {
    //     bus.$emit('PanelSwitchComponent', { name: 'PanelMain' })
    //     next()
    //   }
    // } else {
    //   next()
    // }
  },
  data() {
    return {

    }
  },
  components: { PanelEdit, DeContainer, DeMainContainer },
  computed: {
    fullHeightFlag() {
      return this.$route.path.indexOf('dataModel/edit') > -1
    }
  },
  created() { },
  method: {}
})
</script>

<style lang="scss" scoped>
.ms-aside-container {
  height: calc(100vh - 56px);
  padding: 0px;
  min-width: 260px;
  max-width: 460px;
}

.ms-main-container {
  height: calc(100vh - 56px);
  padding: 0;
}

.full-height {
  height: 100vh !important;
}
</style>
